/**
 * The urgency line above Add to cart.
 *
 * Reads the SAME variant payload the rest of the product page reads
 * ([data-calmy-variants]) and the same hidden input the form submits
 * ([data-calmy-id]), so it can never describe a variant other than the one
 * that would actually be added.
 *
 * It invents nothing. A variant Shopify is not tracking has no count, so the
 * row is hidden rather than filled with a zero. Campaign text is server-
 * rendered and already gated on a real end date, so this script leaves it
 * alone entirely.
 */
(function () {
  "use strict";
  if (window.__calmyUrgency) return;
  window.__calmyUrgency = true;

  function init(row) {
    if (row.__calmyUrgDone) return;
    row.__calmyUrgDone = true;
    if (row.getAttribute("data-static") === "true") return;   // campaign: nothing to update

    var section = row.closest(".shopify-section") || document;
    var idInput = section.querySelector("[data-calmy-id]");
    var dataEl = section.querySelector("[data-calmy-variants]");
    var textEl = row.querySelector("[data-calmy-urgency-text]");
    if (!idInput || !dataEl || !textEl) { row.hidden = true; return; }

    var payload;
    try { payload = JSON.parse(dataEl.textContent); } catch (e) { row.hidden = true; return; }
    var variants = (payload && payload.variants) || [];

    var limit = parseInt(row.getAttribute("data-threshold"), 10);
    if (!(limit > 0)) limit = 10;
    var tpl = row.getAttribute("data-template") || "Only [count] left";
    var soldText = row.getAttribute("data-sold") || "";

    function find(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function update() {
      var v = find(idInput.value);
      if (!v) { row.hidden = true; return; }

      /* Sold out is a fact about the variant and worth saying, tracked or
         not — it is the one message that does not depend on a count. */
      if (v.available === false) {
        if (!soldText) { row.hidden = true; return; }
        textEl.textContent = soldText;
        row.hidden = false;
        return;
      }
      /* No tracking means no number exists. Say nothing. */
      if (!v.tracked) { row.hidden = true; return; }

      var n = parseInt(v.inventory, 10);
      if (!(n > 0) || n > limit) { row.hidden = true; return; }

      textEl.textContent = tpl.replace("[count]", String(n));
      row.hidden = false;
    }

    update();
    /* The hidden input's value is written by the page's own variant logic, so
       watching the attribute is what catches every route into a change —
       swatch, size, bundle tier — without this file having to know any of
       them. */
    if (window.MutationObserver) {
      new MutationObserver(update).observe(idInput, { attributes: true, attributeFilter: ["value"] });
    }
    section.addEventListener("change", function () { window.setTimeout(update, 0); });
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-calmy-urgency]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { boot(); });
  else boot();
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
